import axios from 'axios';

let globalErrorHandler: (message: string, type: 'error' | 'warning' | 'success') => void = () => {};

export const setAxiosErrorHandler = (handler: typeof globalErrorHandler) => {
  globalErrorHandler = handler;
};

const createAxiosInstance = (baseURL: string) => {
  const axiosInstance = axios.create({
    baseURL: baseURL,
    timeout: 180000 // 3 min
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const isLoginRoute = error.config.url.includes('/api/usuarioControllerExterno/login');
      if (isLoginRoute) {
        return Promise.reject(error);
      }
      if (error.code === 'ECONNABORTED') {
        console.error('Timeout: O servidor demorou demais para responder.');
        const message = 'O servidor está demorando mais do que o esperado para responder. Por favor, verifique sua conexão ou tente novamente mais tarde.';
        globalErrorHandler(message, 'error');
        return Promise.reject(new Error('AXIOS_TIMEOUT')); 
        }

        else if (error.code === 'ERR_NETWORK') {
      console.error('Falha de rede: Conexão interrompida ou indisponível.');
      const message = 'Não foi possível estabelecer comunicação com o servidor. Verifique sua conexão com a internet e tente novamente.';
      globalErrorHandler(message, 'warning'); 
      return Promise.reject(new Error('AXIOS_NETWORK_ERROR'));
    }
        else if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        console.warn('Erro de autenticação/autorização:', error.response);
        window.location.href = '/login'; 
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default createAxiosInstance;